/**
 * The "Profiles Delivered" figure (#750), shared by the licence page's At a
 * glance and the licences index: the distinct profiles Invyo delivered over the
 * running contract period, against its yearly target. Pure.
 */

import type { ProfilesDelivered } from '@shared/schemas';

/**
 * `150 / 500`; `150` when no target is set; `-` without a running period (no
 * Contract Start Date yet, or one still to come), like every empty value.
 */
export function profilesDeliveredLabel(delivered: ProfilesDelivered | null | undefined): string {
  if (!delivered) return '-';
  return delivered.target === null ? `${delivered.delivered}` : `${delivered.delivered} / ${delivered.target}`;
}

/** `1 Nov 2025 → 31 Oct 2026`: a contract period's span, both days included. */
export function contractPeriodLabel(period: Pick<ProfilesDelivered, 'period_start' | 'period_end'>): string {
  return `${formatDay(period.period_start)} → ${formatDay(period.period_end)}`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** `2025-11-01` → `1 Nov 2025`, read as a calendar day (no time zone shift). */
export function formatDay(day: string): string {
  const [year, month, date] = day.split('-').map(Number);
  if (!year || !month || !date) return day;
  return `${date} ${MONTHS[month - 1]} ${year}`;
}
